import { DocumentTemplate } from '../../../app/components/credit/shared/models/document-template.model';
import { SectionType } from '../../../app/components/credit/shared/models/section-type.enum';
import { PKL_GRP } from '../../../app/core/shared/models/picklist.model';

export const CREDIT_PROPOSAL_TEMPLATE: DocumentTemplate = {
  id: 'credit-proposal',
  name: 'Credit Proposal',

  sections: [
    {
      id: 'company-introduction',
      title: 'Company Introduction',
      type: SectionType.PARAGRAPH,
      enabled: true,
      order: 1,
      config: {
        refGrp: 28,
        refValSeq: 2519,
        paragraphs: [
          {
            content: '',
          },
        ],
      },
    },
    {
      id: 'highlights',
      title: 'Highlights',
      type: SectionType.BULLET_LIST,
      enabled: true,
      order: 2,
      config: {
        refGrp: 28,
        refValSeq: 2533,
        items: [],
      },
    },
    {
      id: 'terms-parameter',
      title: 'Repayments Terms',
      type: SectionType.TERMS_PARAMETERS,
      enabled: true,
      order: 3,
      config: {
        refGrp: 0,
        refValSeq: 0,
        items: [],
      },
    },
    {
      id: 'Financial-Data',
      title: 'Financial',
      type: SectionType.Financial_data,
      enabled: true,
      order: 4,
      config: {
        refGrp: 28,
        refValSeq: 2536,
      },
    },
      {
      id: 'Extra terms Data',
      title: 'Extra terms',
      type: SectionType.CREDIT_PROPOSAL_EXTRA_TYPE,
      enabled: true,
      order: 5,
      config: {
        refGrp: 28,
        refValSeq: 2669,
      },
    },
      {
      id: 'income-statement-type-credit-proposal',
      title: 'Income Statement',
      type: SectionType.INCOME_STATEMENT_TYPE_CREDIT_PROPOSAL,
      enabled: true,
      order: 6,
      config: {
        refGrp: 28,
        refValSeq: 2619,
      },
    },
      {
      id: 'FinancialAnalysisDetails',
      title: 'Finanical-Analysis-details',
      type: SectionType.FINANCIAL_ANALYSIS_DETIALS,
      enabled: true,
      order: 7,
      config: {
        refGrp: 28,
        refValSeq: 2647,
        selectedRows: [],
      },
    },
  
    {
      id: 'repayment-plan',
      title: 'Repayment Plan',
      type: SectionType.REPAYMENT_PLAN,
      enabled: true,
      order: 8,
      config: {
        refGrp: 0,
        refValSeq: 0,
        disbursements: [],
      },
    },

    {
      id: 'financial-analysis-paragraph',
      title: 'Financial Analysis',
      type: SectionType.PARAGRAPH,
      enabled: true,
      order: 9,
      config: {
        refGrp: 28,
        refValSeq: 2521,
        paragraphs: [
          {
            content: '',
          },
        ],
      },
    },
    {
      id: 'irs-rating-summary',
      title: 'Score on Institutional Rating System Summary',
      type: SectionType.IRS_RATING,
      enabled: true,
      order: 10,
      config: {
        refGrp: 28,
        refValSeq: 2522,
        introduction: '',
        rows: [],
        finalScore: {
          title: 'Final Score',
          currentScore: '',
          currentRating: '',
          previousScore: '',
          previousRating: '',
        },
        conclusion: '',
      },
    },
    {
      id: 'key-risks',
      title: 'Key Risks and Responses',
      type: SectionType.RISK_SECTION,
      enabled: true,
      order: 11,
      config: {
        refGrp: 28,
        refValSeq: 2523,
        items: [],
        conclusion: '',
      },
    },
    {
      id: 'borrower-request',
      title: 'Borrower Request for Funding',
      type: SectionType.PARAGRAPH,
      enabled: true,
      order: 12,
      config: {
        refGrp: 28,
        refValSeq: 2524,
        paragraphs: [
          {
            content: '',
          },
        ],
      },
    },
    {
      id: 'summary-terms',
      title: 'Summary Terms and Conditions',
      type: SectionType.SUMMARY_TERMS,
      enabled: true,
      order: 13,
      config: {
        refGrp: 28,
        refValSeq: 2682,
        items: [],
      },
    },
    {
      id: 'introduction',
      title: 'Introduction',
      type: SectionType.PARAGRAPH,
      enabled: true,
      order: 14,
      config: {
        refGrp: 28,
        refValSeq: 2525,
        paragraphs: [
          {
            content: '',
          },
        ],
      },
    },
    {
      id: 'irs-rating-builder',
      title: 'Score on Institutional Rating System',
      type: SectionType.IRS_RATING_SUMRY,
      enabled: true,
      order: 15,
      config: {
        refGrp: 28,
        refValSeq: 2526,
        introduction: '',
        rows: [],
        finalScore: {
          title: 'Final Score',
          currentScore: '',
          currentRating: '',
          previousScore: '',
          previousRating: '',
        },
        conclusion: '',
      },
    },
    {
      id: 'financial-performance',
      title: 'Financial Performance',
      type: SectionType.FINANCIAL_PERFORMANCE,
      enabled: true,
      order: 16,
      config: {
        refGrp: 28,
        refValSeq: 2527,
        blocks: [],
      },
    },

    {
      id: 'microfinance-plus-update',
      title: 'Microfinance Plus Update',
      type: SectionType.PARAGRAPH,
      enabled: true,
      order: 17,
      config: {
        refGrp: 28,
        refValSeq: 2529,
        paragraphs: [
          {
            content: '',
          },
        ],
      },
    },

    {
      id: 'borrower-proposal-review',
      title: 'Borrower’s Proposal Review',
      type: SectionType.BORROW_PERPOSAL_REVIEW,
      enabled: true,
      order: 18,
      config: {
        refGrp: 28,
        refValSeq: 2530,
      },
    },

    {
      id: 'recommendations',
      title: 'Recommendations',
      type: SectionType.RECOMMENDATIONS,
      enabled: true,
      order: 19,
      config: {
        refGrp: 28,
        refValSeq: 2532,
      },
    },
    {
      id: 'calculate-repayment-plan',
      title: 'Calculate Repayment Plan',
      type: SectionType.CALCULATE_REPAYMENT_PLAN,
      // Temporarily removed from the flow (header nav strip, "SECTION X OF
      // N" count, progress bar, Previous/Next) — component files are left
      // untouched, just not wired into the template for now.
      enabled: false,
      order: 20,
      config: {
        refGrp: 0,
        refValSeq: 0,
      },
    },
    {
      // Supporting documents are uploaded here, before the repayment plan
      // tabs. Not part of the report (refValSeq 0).
      id: 'documents',
      title: 'Documents',
      type: SectionType.DOCUMENTS,
      enabled: true,
      order: 21,
      config: {
        refGrp: 0,
        refValSeq: 0,
      },
    },
    {
      id: 'proposed-disbursement',
      title: 'Calculate Repayment Plan',
      type: SectionType.PROPOSED_DISBURSEMENT,
      enabled: true,
      order: 22,
      config: {
        refGrp: 28,
        refValSeq: 2645,
      },
    },
    {
      id: 'disbursement-repayment-summary',
      title: 'Tentative Disbursements and Repayment Plan',
      type: SectionType.DISBURSEMENT_REPAYMENT_SUMMARY,
      enabled: true,
      order: 23,
      config: {
        refGrp: 0,
        refValSeq: 0,
      },
    },
    
  ],
};
